import dynamic from "next/dynamic";
import { useMedia } from "use-media";
import { media } from "@nju/css";
import { IArticle, ICategory } from "../../faq.machine";

const Desktop = dynamic(async () => {
  return (await import("./Desktop")).Desktop;
});

const Mobile = dynamic(async () => {
  return (await import("./Mobile")).Mobile;
});

interface IStaticFaqProps {
  activeArticleId: string | undefined;
  activeCategoryId: string | undefined;
  categories: ICategory[];
  articles: IArticle[];
  selectCategory: (id?: string) => void;
}

export function StaticFaq({
  categories,
  selectCategory,
  activeArticleId,
  activeCategoryId,
  articles,
}: IStaticFaqProps) {
  const isMobile = useMedia(media.onlyMobile);

  return (
    <>
      {!isMobile && (
        <div data-test-id="static-desktop">
          <Desktop
            activeArticleId={activeArticleId}
            activeCategoryId={activeCategoryId}
            articles={articles}
            categories={categories}
            selectCategory={selectCategory}
          />
        </div>
      )}
      {isMobile && (
        <div data-test-id="static-mobile">
          <Mobile
            activeArticleId={activeArticleId}
            activeCategoryId={activeCategoryId}
            articles={articles}
            categories={categories}
            selectCategory={selectCategory}
          />
        </div>
      )}
    </>
  );
}
